import { HttpClient } from "@angular/common/http";
import { inject, Injectable, Signal, signal } from "@angular/core";
import { map, Observable, tap } from "rxjs";

export interface ISvgSpriteRegisterService {
  registerSprite(): Observable<SVGElement>;
  isExist(id: string): boolean;
  loaded: Signal<boolean>;
}

@Injectable({ providedIn: "root" })
export class SvgSpriteRegisterService implements ISvgSpriteRegisterService {
  private symbolsMap = new Map<string, SVGElement>();

  loaded = signal(false);

  private readonly _http = inject(HttpClient);

  registerSprite() {
    return this._http
      .get("assets/sprites/sprite.svg", { responseType: "text" })
      .pipe(
        map((res) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(res, "image/svg+xml");
          const svg = doc.documentElement as unknown as SVGElement;

          return svg;
        }),
        tap((svg) => {
          const symbols = svg.querySelectorAll("symbol");

          symbols.forEach((symbol) => {
            this.symbolsMap.set(symbol.id, symbol);
          });
          this.loaded.set(true);
        }),
      );
  }

  isExist(id: string): boolean {
    return this.symbolsMap.has(id);
  }
}
